<template>
    <!-- <div @click="propertyLogsMethod(dataObject.property_id)" class="mb-4">
        <router-link
            :to="{
                name: 'property.board.detail',
                params: {
                    id: dataObject.board_id,
                    propertyId: dataObject.property_id,
                },
            }"
        >
            <div
                class="item_inner flex items-start px-3 py-4 border border-gray-200 rounded-lg hover:bg-gray-100"
            >
                <div class="item_left">
                    <img
                        :src="
                            dataObject.property_image
                                ? dataObject.property_image
                                : '/src/assets/images/property-thumb.jpg'
                        "
                        alt=""
                        class="h-8 rounded"
                    />
                </div>
                <div class="item_right ml-2">
                    <h4
                        class="text-sm font-medium text-black-900 leading-4"
                        data-v-0cd87ba4=""
                    >
                        £
                        <span v-html="dataObject.price"></span>
                        <span>-</span>
                        <span v-html="dataObject.bedrooms"></span>
                        <span>-</span>
                        <span v-html="dataObject.type"></span>
                    </h4>
                    <p
                        class="text-black-900 text-xs mb-2 font-light"
                        data-v-0cd87ba4=""
                    >
                        <span v-html="dataObject.name"></span>
                        -
                        <span v-html="dataObject.address_line_1"></span>
                        <span v-html="dataObject.address_line_2"></span>
                    </p>
                    <div class="bottom_section flex items-center">
                        <template
                            v-for="(user, userIndex) in dataObject.users"
                            :key="userIndex"
                        >
                            <div>
                                <img
                                    :src="getUserImage(user.image_path)"
                                    :alt="user.first_name"
                                    class="w-6 h-6 rounded-full mr-2"
                                />
                            </div>
                        </template>
<template v-for="(label, labelIndex) in dataObject.labels" :key="labelIndex">
                            <div class="mr-2">
                                <app-label
                                    :classes="label.color"
                                    :text="label.name"
                                ></app-label>
                            </div>
                        </template>
<div>
    <app-label :text="'step' + dataObject.steps.step_level" :isStep="true"
        :secondText="dataObject.steps.step_name"></app-label>
</div>
</div>
</div>
</div>
</router-link>
</div> -->

    <div v-for="i in 5" :key="i" class="flex gap-[77px] items-center mb-6 last-of-type:mb-0">
        <div class="flex items-center gap-4 last-of-type:mb-0 lg:min-w-[315px] md:min-w-[235px]">
            <div class="board_card__img !rounded-[2px] !h-[48px] !w-auto">
                <img src="@/assets/images/property_img.png" alt="property image">
            </div>
            <div class="board_card__info">
                <h6 class="board_card__heading text-base max-w-[22rem]"> £650k - Studio flat for sale
                </h6>
                <p class="board_card__address text-sm max-w-[22rem] !mb-0">23 Manor Road London W34 7UK</p>
            </div>
        </div>
        <div class="flex justify-between items-center gap-[41px] w-full">
            <div class="contact-reference text-nowrap">
                <p class="text-xs text-black-900 leading-none">For sale | Residential: On the market</p>
            </div>
            <div class="contact-users">
                <img class="w-6 rounded-full" src="@/assets/images/user.png" alt="imran">
            </div>
        </div>
    </div>

</template>
<script setup>
import AppLabel from '@/components/AppLabel.vue';
import { getUserImage } from '@/composables/globals';
const emits = defineEmits(['propertyLogs']);
defineProps({
    dataObject: {
        type: Object,
        default: () => { },
    },
});
const propertyLogsMethod = (id) => {
    emits('propertyLogs', {
        type: 'property',
        property_id: id,
        search_from: 'search',
    });
};
</script>
<style scoped></style>
